import { useSnapshot } from 'valtio';

import EmbedPage from 'components/pages/EmbedPage';
import LandingPage from 'components/pages/LandingPage';
import Motion from 'components/pages/Motion';
import PoseMode from 'components/pages/PoseMode';
import Projects from 'components/pages/Projects';
import Studio from 'components/pages/Studio';
import { navigationStore } from 'stores';

export default function PageManager() {
  // Subscribe to navigation state changes to trigger re-renders
  useSnapshot(navigationStore.state);

  let pageToShow = <></>;
  if (navigationStore.matchesRoute('home')) {
    pageToShow = <Studio />;
  } else if (navigationStore.matchesRoute('embed')) {
    pageToShow = <EmbedPage />;
  } else if (navigationStore.matchesRoute('projects')) {
    pageToShow = <Projects />;
  } else if (navigationStore.matchesRoute('pose/:projectID')) {
    pageToShow = <PoseMode />;
  } else if (navigationStore.matchesRoute('motion/:projectID')) {
    pageToShow = <Motion />;
  } else {
    pageToShow = <LandingPage />;
  }

  return pageToShow;
}
